import { AxiosInstance } from 'axios'

import { userApiDefaultApiFactory } from '@src/api/default-api-factories'
import {
  DefaultApiLockCardForPotentialFraudRequest,
  DefaultApiUnlockCardForNotPotentialFraudRequest,
  DefaultApiUnlockCardOnFraudClearedRequest,
  DefaultApiGetDefaultCommentTemplateRequest,
  DefaultApiRequestSendingRequest,
  DefaultApiPostCardsVirtualIssueRequest,
  DefaultApiGetOrganizationCardsLightRequest,
  DefaultApiGetCardBillRequest,
  DefaultApiReissueCardRequest,
  DefaultApiDeactivateCardRequest,
  DefaultApiCreateEtcCardIssuanceRequestRequest,
  // Do Not Remove this line ===@import api type===
} from '@src/api/generated/user-api'

/**
 * @deprecated This will be replaced by the method for an api for new lock type
 */
export const lockCardForPotentialFraud = async (
  instance: AxiosInstance,
  params: DefaultApiLockCardForPotentialFraudRequest
) => {
  return await userApiDefaultApiFactory(instance).lockCardForPotentialFraud(
    params
  )
}

/**
 * @deprecated This will be replaced by the method for an api for new lock type
 */
export const unlockCardForNotPotentialFraud = async (
  instance: AxiosInstance,
  params: DefaultApiUnlockCardForNotPotentialFraudRequest
) => {
  return await userApiDefaultApiFactory(
    instance
  ).unlockCardForNotPotentialFraud(params)
}

export const unlockCardOnFraudCleared = async (
  instance: AxiosInstance,
  params: DefaultApiUnlockCardOnFraudClearedRequest
) => {
  return await userApiDefaultApiFactory(instance).unlockCardOnFraudCleared(
    params
  )
}

export const getDefaultCommentTemplate = async (
  instance: AxiosInstance,
  params: DefaultApiGetDefaultCommentTemplateRequest
) => {
  return await userApiDefaultApiFactory(instance).getDefaultCommentTemplate(
    params
  )
}

export const postCardsVirtualIssue = async (
  instance: AxiosInstance,
  params: DefaultApiPostCardsVirtualIssueRequest
) => {
  return await userApiDefaultApiFactory(instance).postCardsVirtualIssue(params)
}

export const requestSending = async (
  instance: AxiosInstance,
  params: DefaultApiRequestSendingRequest
) => {
  return await userApiDefaultApiFactory(instance).requestSending(params)
}

export const getOrganizationCardsLight = async (
  instance: AxiosInstance,
  params: DefaultApiGetOrganizationCardsLightRequest
) => {
  return await userApiDefaultApiFactory(instance).getOrganizationCardsLight(
    params
  )
}

export const getCardBill = async (
  instance: AxiosInstance,
  params: DefaultApiGetCardBillRequest
) => {
  return await userApiDefaultApiFactory(instance).getCardBill(params)
}

export const reissueCard = async (
  instance: AxiosInstance,
  params: DefaultApiReissueCardRequest & { token: string | null }
) => {
  const headers = params.token
    ? { Authorization: `Bearer ${params.token}` }
    : {}

  return await userApiDefaultApiFactory(instance).reissueCard(params, {
    headers,
  })
}

export const deactivateCard = async (
  instance: AxiosInstance,
  params: DefaultApiDeactivateCardRequest
) => {
  return await userApiDefaultApiFactory(instance).deactivateCard(params)
}

export const createEtcCardIssuanceRequest = async (
  instance: AxiosInstance,
  params: DefaultApiCreateEtcCardIssuanceRequestRequest
) => {
  return await userApiDefaultApiFactory(instance).createEtcCardIssuanceRequest(
    params
  )
}

// Do Not Remove this line ===@import api client===
